import React, { useContext } from 'react';

import EditOwners from 'components/EditOwners';
import { useDispatch } from 'react-redux';

import { addOwnerType, removeCommonToIdsFromCollaborators, selectOwners } from 'services/helpers/task';
import { showErrorSnackbar } from 'services/snackbar';

import { EmployeesEditContext } from '.';

export default function OwnersEdit({
  teamId,
  rightJustified = false,
  filterEmpIds = null,
  reactSelectComponentsOverride = {},
}) {
  const { employees, onUpdate } = useContext(EmployeesEditContext);
  const owners = selectOwners(employees);
  const dispatch = useDispatch();

  function onRemoveOwner(removedOwner, updatedOwners) {
    // throws error when user tries to remives all the owners
    if (employees.length === 1) {
      dispatch(showErrorSnackbar('Must have an owner!'));
      return;
    }
    // remove the employee from list of employees
    const newEmployees = employees.filter((employee) => employee.id !== removedOwner.id);
    onUpdate(newEmployees);
  }

  function onUpdateOwner(updatedOwners) {
    if (!updatedOwners) return;
    const ownersWithUpdatedOwnerType = addOwnerType(updatedOwners);
    const newEmployees = removeCommonToIdsFromCollaborators(employees, ownersWithUpdatedOwnerType);
    onUpdate(newEmployees);
  }

  return (
    <EditOwners
      teamId={teamId}
      employees={owners}
      removeEmployee={onRemoveOwner}
      updateEmployees={onUpdateOwner}
      rightJustified={rightJustified}
      filterEmpIds={filterEmpIds}
      reactSelectComponentsOverride={reactSelectComponentsOverride}
    />
  );
}
